import { Box, Button, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import './App.css';
import { useProject } from "./hooks/useProject.jsx";
import ProjectList from "./components/ProjectList/ProjectList.jsx";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen.jsx";
import BackgroundManager from "./components/BackgroundManager/BackgroundManager.jsx";
import { useMediaQuery } from "@mui/material";
import River from "./components/River/River.jsx";
import Infos from "./components/Infos/Infos.jsx";
import { useBackground } from "./hooks/useBackgroundManager.jsx";

function App() {
  const { setCurrentHoverProject, isLoading, setCurrentProject } = useProject();
  const [whiteBandOpen, setWhiteBandOpen] = useState(false);
  const [infoDisplayed, setInfoDisplayed] = useState(false);
  const isMobile = useMediaQuery('(max-width:800px)');
  const { textColor } = useBackground();

  useEffect(() => {
    const handlePopState = () => {
      if (infoDisplayed) {
        setInfoDisplayed(false);
        window.history.pushState(null, null, window.location.pathname); // Remet l'état dans l'historique
      } else if (whiteBandOpen) {
        resetWhiteBand();
        window.history.pushState(null, null, window.location.pathname);
      }
    };

    if (infoDisplayed || whiteBandOpen) {
      window.history.pushState(null, null, window.location.pathname); // Ajoute un état si Infos ou la rivière est ouvert
    }

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [whiteBandOpen, infoDisplayed]);


  const onProjectClick = (projectName) => {
    setCurrentProject(projectName);
    setWhiteBandOpen(true);
  };

  const displayOrHideInfos = () => {
    setInfoDisplayed(!infoDisplayed);
  }

  const resetWhiteBand = () => {
    setWhiteBandOpen(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code === "Escape") {
        if (infoDisplayed) {
          setInfoDisplayed(false);
        }
        else {
          resetWhiteBand();

        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [infoDisplayed]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh" }}>
        <BackgroundManager />
        {!whiteBandOpen && !infoDisplayed && isMobile &&
          <Box sx={{
            paddingTop: "5vh",
            display: "flex",
            flexDirection: "row-reverse",
            width: "100%"
          }}>
            <Button onClick={displayOrHideInfos} sx={{
              fontFamily: "Roboto",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "inherit", // Pas de changement au hover
              },
            }}>
              <Typography fontFamily={"Roboto"} sx={{
                color: textColor,
                fontSize: "1em"

              }} >
                À propos
              </Typography>
            </Button>
          </Box>
        }
        {
          infoDisplayed ?
            <Box
              sx={{
                height: "100%",
                width: "100%",
                backgroundColor: "#0E101F"
              }}>
              <Infos hideInfos={displayOrHideInfos} />
            </Box>
            :
            <Box
              onMouseLeave={() => setCurrentHoverProject(undefined)}
              sx={{
                position: isMobile ? "fixed" : "relative",
                bottom: isMobile ? "10vh" : "none",
                zIndex: 1,
                width: "600px",
                marginTop: "200px",
              }}
            >
              <ProjectList onProjectClick={onProjectClick} />
            </Box>
        }
        {!isMobile && !infoDisplayed &&
          <Box sx={{
            position: "fixed",
            bottom: "45px",
            left: "0px",
            marginLeft: "75px"
          }}>
            <Button onClick={displayOrHideInfos} sx={{
              fontFamily: "Roboto",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "inherit", // Pas de changement au hover
              },
            }}>
              <Typography fontFamily={"Roboto"} sx={{
                color: textColor,
                fontSize: "1em",
                "&:hover": {
                  backgroundColor: "inherit", // Pas de changement au hover
                  fontWeight: "bold"
                },
              }} >
                À propos
              </Typography>
            </Button>
          </Box>
        }
      </Box>
      <River resetWhiteBand={resetWhiteBand} whiteBandOpen={whiteBandOpen} displayInfos={displayOrHideInfos} />


    </>
  );
}

export default App;
